"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationMap = exports.joinPageStatus = exports.VIDEO_PERMISSION_DENIED = exports.READINESS_ISSUES = exports.NO_NOTIFICATION = exports.MICROPHONE_IN_USE_NOTIFICATION = exports.CAMERA_IN_USE_NOTIFICATION = exports.AUDIO_VIDEO_PERMISSION_DENIED = exports.AUDIO_PERMISSION_DENIED = exports.ALL_OK_STANDALONE = exports.ALL_OK_SPEAKER = exports.ALL_OK_HOST = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _notificationMap;
var joinPageStatus = exports.joinPageStatus = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETE: 'complete',
  ERROR: 'error',
  BROWSER_BLOCK: 'browser_block'
};
var AUDIO_VIDEO_PERMISSION_DENIED = exports.AUDIO_VIDEO_PERMISSION_DENIED = 'AUDIO_VIDEO_PERMISSION_DENIED';
var AUDIO_PERMISSION_DENIED = exports.AUDIO_PERMISSION_DENIED = 'AUDIO_PERMISSION_DENIED';
var VIDEO_PERMISSION_DENIED = exports.VIDEO_PERMISSION_DENIED = 'VIDEO_PERMISSION_DENIED';
var READINESS_ISSUES = exports.READINESS_ISSUES = 'READINESS_ISSUES';
var ALL_OK_SPEAKER = exports.ALL_OK_SPEAKER = 'ALL_OK_SPEAKER';
var ALL_OK_HOST = exports.ALL_OK_HOST = 'ALL_OK_HOST';
var ALL_OK_STANDALONE = exports.ALL_OK_STANDALONE = 'ALL_OK_STANDALONE';
var NO_NOTIFICATION = exports.NO_NOTIFICATION = 'NO_NOTIFICATION';
var CAMERA_IN_USE_NOTIFICATION = exports.CAMERA_IN_USE_NOTIFICATION = 'CAMERA_IN_USE_NOTIFICATION';
var MICROPHONE_IN_USE_NOTIFICATION = exports.MICROPHONE_IN_USE_NOTIFICATION = 'MICROPHONE_IN_USE_NOTIFICATION';
var notificationMap = exports.notificationMap = (_notificationMap = {}, (0, _defineProperty2["default"])(_notificationMap, AUDIO_VIDEO_PERMISSION_DENIED, {
  message: 'Open your browser settings and allow access to the camera and microphone.',
  type: 'warning',
  linkMessage: 'Get help',
  onClick: function onClick() {
    return window.open('https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility', '_blank', 'noopener');
  }
}), (0, _defineProperty2["default"])(_notificationMap, AUDIO_PERMISSION_DENIED, {
  message: 'Open your browser settings and allow access to the microphone.',
  type: 'warning',
  linkMessage: 'Get help',
  onClick: function onClick() {
    return window.open('https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility', '_blank', 'noopener');
  }
}), (0, _defineProperty2["default"])(_notificationMap, VIDEO_PERMISSION_DENIED, {
  message: 'Open your browser settings and allow access to the camera.',
  type: 'alert',
  linkMessage: 'Get help',
  onClick: function onClick() {
    return window.open('https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility', '_blank', 'noopener');
  }
}), (0, _defineProperty2["default"])(_notificationMap, READINESS_ISSUES, {
  message: 'Check these issues to get a better experience. Go to system check.',
  type: 'alert'
}), (0, _defineProperty2["default"])(_notificationMap, CAMERA_IN_USE_NOTIFICATION, {
  message: 'Your camera is currently in use by another app. Close it to access your camera.',
  type: 'alert'
}), (0, _defineProperty2["default"])(_notificationMap, MICROPHONE_IN_USE_NOTIFICATION, {
  message: 'Your microphone is currently in use by another app. Close it to access your microphone.',
  type: 'alert'
}), (0, _defineProperty2["default"])(_notificationMap, ALL_OK_HOST, {
  message: "You're all set! You won't be seen or heard by the audience when you join.",
  type: 'success'
}), (0, _defineProperty2["default"])(_notificationMap, ALL_OK_STANDALONE, {
  message: 'All tests passed.',
  type: 'success'
}), (0, _defineProperty2["default"])(_notificationMap, ALL_OK_SPEAKER, {
  message: 'The host has arrived. You can join now!',
  type: 'success'
}), (0, _defineProperty2["default"])(_notificationMap, NO_NOTIFICATION, {
  message: '',
  linkMessage: '',
  type: 'success',
  onClick: function onClick() {}
}), _notificationMap);